import { I } from '@angular/cdk/keycodes';
import { Component, Inject, OnInit, SimpleChanges } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { lastValueFrom } from 'rxjs';
import { AuthService } from 'src/app/services/auth.service'; 
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { FaceSheetService } from '../../patient-detail/facesheet/face-sheet.service'; 
@Component({
  selector: 'app-pdf-viewer-pop',
  templateUrl: './pdf-viewer-pop.component.html',
  styleUrls: ['./pdf-viewer-pop.component.css']
})
export class PdfViewerPopComponent implements OnInit {
  
  file_path: any;
  image_files = ['.jpg', '.jpeg', '.png'];
  file: any;
  patient: any;
  chargePatient: any;
  coverages: any;
  loaderId = 'facesheet-loader';
  patientCoverages;
  secondaryIns = '';
  showData: boolean = false;
  isDNPatient: boolean = false;
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: PdfViewerPopComponent,
    
    public _authService: AuthService, 
    private toastr: ToastrService, 
    private loader: NgxUiLoaderService,
    private faceSheetService: FaceSheetService
    ) {
        if(this.data && this.data.file_path){
          this.file_path = this.data.file_path
        }
  }

  async ngOnInit() {
    this.toastr.info('Loading...', 'Please wait', { disableTimeOut: true });
    this.loadPDF()
    if (this.chargePatient) {
      const patient_id = this.chargePatient._id; 
      await this.syncCoveragesData(patient_id);
    }
  }
  ngOnChanges(changes: SimpleChanges) {
    if (changes.file_path) {
      this.loadPDF();
    }
  }

  checkImageFile() {
    return this.image_files.some(file => this.file_path?.includes(file));
  }

  loadPDF(){
    if (this.data && this.data.file_path) {
      this.file_path = this.data.file_path
    }
    if (this.data && this.data.file) {
      this.file = this.data.file
      this.chargePatient = this.file.patient_id
    }
  }
  async downloadFacesheeet(patient_id = null){
    if(this.data?.file?.faceSheet?.aws_path){
      let aws_path = this.data.file.faceSheet.aws_path;
      let title = this.data.file.faceSheet.title;
      let patient_id = this.data.file.patient_id?._id;
      this.faceSheetService.downloadUploadedFile(aws_path, title, patient_id);
    }
    else if(this.patient && this.coverages){
      const coverageData = { 
        patient: this.patient,
        coverages : this.coverages
      }
      this.faceSheetService.generateFacesheetAndDownloadAsPDF(coverageData);
    }
    else{
      this.toastr.error('Unable to download file.', 'Failed');
    }
  }

  generateFacesheetAndDownload(){
    const coverageData = { 
      patient: this.patient,
      coverages : this.coverages
    }
    this.faceSheetService.generateFacesheetAndDownloadAsPDF(coverageData);
  }

  getLevelName(number: number ) {
    switch (number) {
        case 1:
            return "Primary";
        case 2:
            return "Secondary";
        case 3:
            return "Tertiary";
        default:
            return "Other";
    }
  }
  async syncCoveragesData(patientId) {
    this.loader.startLoader(this.loaderId);
    const details = {
      ...this._authService.authObject,
      patientId,
    };
  
    if(!this.data.file_path){ 
      const {status, data} =  await lastValueFrom(this.faceSheetService.getCoveragesData({details})) as any;
      if (status === 200) {
        this.patient = data.patient_data;
        this.coverages = data.coverage_data;
        this.showData = true; 
      }
      else{
        this.toastr.error('Unable to fetch patient coverages data', 'Error');
      }
    }
    this.toastr.clear();
    this.loader.stopLoader(this.loaderId);

  }
  ngOnDestroy(){
    this.file_path 
    this.file,
    this.isDNPatient,
    this.patient
    this.chargePatient
    this.coverages
  }
}

